import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleRegresar = () => {
    const params = new URLSearchParams(window.location.search);
    const returnTo = params.get("returnTo");
    if (!returnTo || !returnTo.startsWith("/") || returnTo.includes("//") || returnTo.includes("\\")) {
      navigate("/usuario/campus");
      return;
    }
    try {
      const decoded = decodeURIComponent(returnTo);
      const url = new URL(decoded, window.location.origin);
      if (url.origin !== window.location.origin || !url.pathname.startsWith("/")) {
        navigate("/usuario/campus");
        return;
      }
      navigate(decoded);
    } catch {
      navigate("/usuario/campus");
    }
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      textAlign: 'center',
      backgroundColor: '#0d1b2a',
      color: '#fff',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '600px',
        padding: '40px',
        borderRadius: '10px',
        backgroundColor: '#14283d',
        boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
        border: '1px solid #17a398'
      }}>
        <h1 style={{ fontSize: '4rem', color: '#17a398', margin: '0 0 20px 0' }}>404</h1>
        <h2 style={{ marginBottom: '20px' }}>Página no encontrada</h2>
        <p style={{ fontSize: '1.1rem', marginBottom: '30px', color: '#ccc' }}>
          Lo sentimos, la página que estás buscando no existe.
        </p>
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
          <Link 
            to="/" 
            style={{
              backgroundColor: '#17a398',
              color: '#0d1b2a',
              padding: '12px 24px',
              textDecoration: 'none',
              borderRadius: '5px',
              fontWeight: 'bold',
              transition: 'background-color 0.2s'
            }}
          >
            Volver al Inicio
          </Link>
          <button
            type="button"
            onClick={handleRegresar}
            style={{
              backgroundColor: 'transparent',
              border: '1px solid #17a398',
              color: '#17a398',
              padding: '12px 24px',
              borderRadius: '5px',
              fontWeight: 'bold',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            Regresar
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
